var _defs, _rect, _path, _path2, _rect2, _circle, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVaknlLgLuggage = function SvgVaknlLgLuggage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "vaknl-lg-luggage_svg__Laag_1",
    "data-name": "Laag 1",
    viewBox: "0 0 40 40"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".vaknl-lg-luggage_svg__cls-5,.vaknl-lg-luggage_svg__cls-7{stroke:#282828;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px}.vaknl-lg-luggage_svg__cls-4,.vaknl-lg-luggage_svg__cls-7{fill:#fff}.vaknl-lg-luggage_svg__cls-5{fill:none}"))), /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 18,
    x: 7,
    y: 12.5,
    rx: 3.065,
    style: {
      strokeWidth: "1.5px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      stroke: "#282828",
      fill: "#3d9b8b"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.029,
    cy: 18.514,
    r: 2.971,
    style: {
      fill: "#f3ad05",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 3,
    x: 14.058,
    y: 22.514,
    rx: 0.632,
    style: {
      fill: "#288374"
    },
    transform: "rotate(-45 16.058 24.014)"
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 3,
    x: 27.442,
    y: 22.089,
    className: "vaknl-lg-luggage_svg__cls-4",
    rx: 0.632,
    transform: "rotate(16.13 29.415 23.565)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 12.5v-.668A2.84 2.84 0 0 1 17.332 9h5.336a2.84 2.84 0 0 1 2.832 2.832v.668",
    className: "vaknl-lg-luggage_svg__cls-5"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M33 26a3.065 3.065 0 0 1-3.065 3.065h-19.87A3.065 3.065 0 0 1 7 26",
    style: {
      stroke: "#288374",
      fill: "none",
      strokeWidth: "1.5px",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 12.5h3v18h-3z",
    className: "vaknl-lg-luggage_svg__cls-7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 18,
    x: 7,
    y: 12.5,
    className: "vaknl-lg-luggage_svg__cls-5",
    rx: 3.065
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 21,
    r: 2,
    className: "vaknl-lg-luggage_svg__cls-4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 12.5h3v18h-3z",
    className: "vaknl-lg-luggage_svg__cls-7"
  })));
};
export default SvgVaknlLgLuggage;